import {createElement, PropTypes} from 'rlink-react';
import {ContentImg} from 'rlink-repos/content-components';

export default function ShopItemBackgroundImage ({css, backgroundPath, squareBackgroundPath}) {
  let images = [];
  if (backgroundPath) {
    images.push(<ContentImg key={backgroundPath} className={`${css['poster-background']}
      ${(squareBackgroundPath)
        ? css['has-mobile']
        : ''}`} src={backgroundPath} />);
  }
  if (squareBackgroundPath) {
    images.push(<ContentImg key={squareBackgroundPath} className={css['background-mobile']} src={squareBackgroundPath} />);
  }
  return (<div>
    {images}
  </div>);
}

ShopItemBackgroundImage.propTypes = {
  css: PropTypes.object,
  backgroundPath: PropTypes.string,
  squareBackgroundPath: PropTypes.string,
};

ShopItemBackgroundImage.defaultProps = {
  backgroundPath: '',
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/ShopItemBackgroundImage.jsx